import React from "react";
import {DefaultDataTable} from "../../../components/dataTable/DefaultDataTable";

export const NotaEntradaList = props => <DefaultDataTable data={props} />;
